// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import AuditStatus from '@deere/cps-it.warranty-model-factory/lib/audit-status';
import DivisionSummaryPanel from './division-summary-panel';
import ReportList from './report-list';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

class AuditStatusReport extends Component {

    componentWillMount() {

        this.props.actions.readAuditStatus();

    }

    componentWillUnmount() {

        this.props.actions.resetAuditStatus();
        this.props.actions.updateShowNoResultsFound(false);

    }

    render() {

        return (
            <section className='audit-status-report'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <main>
                    {this.props.showNoResultsFound ?
                        <ShowNoResultsFound showNoResultsFound={true}/> :
                        <ReportList tcsm={this.props.auditStatus.divisionSummary.tcsm}/>
                    }
                </main>
                <aside>
                    {this.props.auditStatus.isDcsm &&
                        <DivisionSummaryPanel divisionSummary={this.props.auditStatus.divisionSummary}/>
                    }
                </aside>
            </section>
        );

    }

}

AuditStatusReport.displayName = 'AuditStatusReport';
AuditStatusReport.propTypes = {
    actions: PropTypes.object.isRequired,
    auditStatus: PropTypes.instanceOf(AuditStatus).isRequired,
    busyCounter: PropTypes.number.isRequired,
    showNoResultsFound: PropTypes.bool.isRequired
};

export default AuditStatusReport;



// WEBPACK FOOTER //
// ./src/reports/audit-status/components/index.js